export default "__VITE_ASSET__07187359__"